import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Inputfield from "../Textfield/Textfield";
import Buttons from "../Button/Button";
import ShareIcon from "@mui/icons-material/Share";
import FacebookIcon from "@mui/icons-material/Facebook";
import TwitterIcon from "@mui/icons-material/Twitter";
import "./Modal.scss";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { useTranslation } from "react-i18next";
import { Storage, Auth, API, graphqlOperation } from "aws-amplify";
import {
  createGarment,
  updateProductTable,
  createUserInfo,
  updateUserInfo,
} from "../../graphql/mutations";
import Snackbar from "../Snackbar/Snackbar";
import { SliderPicker } from "react-color";
import { login } from "../../store/action";
import { productById, listUserInfos, byUserId } from "../../graphql/queries";
import { campaignData, productData, draftId } from "../../store/action";
import { Tooltip } from "@mui/material";
import { CopyToClipboard } from "react-copy-to-clipboard";
import upload from "../../assets/upload.png";
import { FacebookShareButton, TwitterShareButton } from "react-share";
import CatergorySelect from "../Multiselect/Categoryselect";
import ProductCategory from "./ProductCatgory";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 550,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  border: "1px solid #000",
};
export default function Modals({
  setopenmodal,
  openmodal,
  condition,
  setIcon,
  settgarments,
  uploadsection,
  item,
  escape,
  weflowProductURL,
  editCat,
  catItem,
}) {
  const dataurl1 = [];
  const draftProductId = useSelector((state) => state.draftId.draftProductId);
  const [copied, setCopied] = useState(false);
  const [data, setData] = useState(window?.location?.href);
  const history = useHistory();
  const [auth, setauth] = useState("signin");
  const dispatch = useDispatch();
  const [frtimgaddress, setfrtimageAdress] = useState("");
  const [bckimgaddress, setbckimgaddress] = useState("");
  const [congrates, setcongrats] = useState(
    condition === "donePreview" ? true : false
  );
  const [price, setprice] = useState("");
  const [shirtname, setshirtname] = useState("");
  const [description, setdescription] = useState("");
  const [personName, setPersonName] = useState([]);
  const [email, setEmail] = useState("");
  const [emailerror, setEmailError] = useState(false);
  const [password, setpassword] = useState("");
  const [passwordError, setpasswordError] = useState(false);
  const [msg, setmsg] = useState("");
  const [errMsg, seterrMsg] = useState("");
  const [authstate, setAuthstate] = useState("auth");
  const [verifycode, setVerifycode] = useState("");
  const [databtn, setdatabtn] = useState(false);
  const [loader1, setloader1] = useState(false);
  const [loader2, setloader2] = useState(false);
  const [color, setColor] = useState("#000000");
  const [code, setCode] = useState("");
  const [colArray, setColarr] = useState([]);
  const [categoryData, setcategoryData] = useState([]);
  const [userName, setUsername] = useState("");
  const [userNameError, setUserNameError] = useState("");
  const [webflowShirt, setwebflowShirt] = useState([]);
  const [webflowData, setwebflowData] = useState([]);
  const product = useSelector((state) => state.product);
  const logindata = useSelector((state) => state.login);
  const { t } = useTranslation();

  const modalcondFunc = () => {
    setAuthstate("auth");
    setCode("");
    setVerifycode("");
    setopenmodal(false);
    setEmail("");
    setpassword("");
  };
  const describeroute = () => {
    history.push("/describecampaign");
  };
  const doneprevroute = async () => {
    setdatabtn(true);
    const getId = localStorage.getItem("email");
    let users;
    let nextTokens;

    do {
      users = await API.graphql(
        graphqlOperation(byUserId, {
          userId: getId,
          nextTokens,
          limit: 500,
        })
      );
      nextTokens = users.data.byUserId.nextToken;
    } while (nextTokens);
    if (logindata.userName && !logindata.WebflowCustomerId) {
      API.post("laetusapi", "/api/v1/addCustomer", {
        body: {
          userName: logindata.userName,
          email: logindata.email,
        },
      })
        .then(async (res) => {
          try {
            const user = {
              WebflowCustomerId: res._id,
              id: users.data.byUserId.items[0].id,
            };

            const data = await API.graphql(
              graphqlOperation(updateUserInfo, {
                input: user,
              })
            );
            uploadProduct(res._id);
            dispatch(
              login({
                ...logindata,
                WebflowCustomerId: res._id,
              })
            );
          } catch (err) {
            setdatabtn(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      uploadProduct(logindata.WebflowCustomerId);
    }
  };
  const uploadProduct = async (id) => {
    setmsg("");
    seterrMsg("");
    const shirt = {
      isDone: true,
    };
    const url = "www.laetus-store.com/product/";
    const categorydata = [];
    await product.shirt.category.map((data) => {
      const idData = data.webflowId ? data.webflowId : data.id;
      categorydata.push(idData);
    });
    const convertToEng = product.shirtname
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    let shirtnameUpdated = convertToEng.replace(/[^\w\s-]/g, "");
    shirtnameUpdated = shirtnameUpdated.toLowerCase().replace(/ /g, "-");
    API.post("laetusapi", "/api/v1/addproduct", {
      body: {
        shirtname: product.shirtname,
        description: product.brief,
        days: product.day,
        category: categorydata,
        seller: id,
        frontimage: product.designnimg,
        backimage: product.designnimgback,
        price: product.sellingPrice,
        garmentnameid: product?.shirt?.garmentName?.id,
        shirtnameUpdated: shirtnameUpdated,
      },
    })
      .then(async (res) => {
        try {
          const data = await API.graphql(
            graphqlOperation(updateProductTable, {
              input: {
                ...{
                  isStop: false,
                  isDone: true,
                  weflowProductId: res.product._id,
                  weflowProductURL:
                    url +
                    product?.shirt?.garmentName?.id +
                    "-" +
                    shirtnameUpdated,
                },
                id: draftProductId,
              },
            })
          );

          dispatch(
            draftId({
              draftProductId: "",
            })
          );
          dispatch(
            productData({
              id: "",
              step: 0,
              shirt: {},
              designnimg: "",
              color: "",
              realprice: 0,
              price: 0,
              day: 0,
              sales: 0,
              shirtname: "",
              brief: "",
              detail: "",
              campaign: 0,
              shirtdesign: [],
              shirtdesignback: [],
              frontDesignObj: null,
              backDesignObj: null,
              alterImage: null,
              edit: false,
              hello: {},
              seldata: false,
              shirtsdata1: "",
              shirtsdata2: "",
            })
          );
          setmsg("Successfully added");
          setdatabtn(false);
          setcongrats(true);
          setTimeout(function () {
            history.push(`/donepreview/${data?.data?.updateProductTable?.id}`);
            setcongrats(false);
          }, 2000);
        } catch (error) {
          seterrMsg(error.message);
          setdatabtn(false);
        }
      })
      .catch((err) => {
        setdatabtn(false);
        return err;
      });
  };

  const handleimagefrt = (e) => {
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function () {
      setfrtimageAdress(reader.result);
    };
  };
  const handleimagebck = (e) => {
    var reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);
    reader.onload = function () {
      setbckimgaddress(reader.result);
    };
  };

  const uploadshirt = async (webflowData) => {
    const pic = [frtimgaddress, bckimgaddress];
    for (let index = 0; index < pic?.length; index++) {
      const filename = Date.now();
      const base64Data = new Buffer.from(
        pic[index].replace(/^data:image\/\w+;base64,/, ""),
        "base64"
      );
      const Store = await Storage.put(
        "designproducts/" + filename,
        base64Data,
        {
          ContentEncoding: "base64",
          ContentType: `image/png`,
          Acl: "public-read",
          contentDisposition: "attachment",
        }
      );
      const url = await Storage.get(Store.key);
      dataurl1.push(url.split("?")[0]);
    }

    const garment = await {
      frontImg: dataurl1[0],
      backImg: dataurl1[1],
      frontImgaddress: dataurl1[0].split("public/")[1],
      backImgaddress: dataurl1[1].split("public/")[1],
      garmentName: {
        name: webflowData.name,
        id: webflowData._id,
      },
      cost: price,
      category: categoryData.map((cat) => ({
        webflowId: cat.webflowId,
        id: cat.id,
        categoryName: cat.categoryName,
      })),
      color: colArray,
      garmentDescription: description,
    };
    try {
      const garmentData = await API.graphql(
        graphqlOperation(createGarment, { input: garment })
      );
      setmsg("Successfully added");
      setfrtimageAdress("");
      setbckimgaddress("");
      setprice("");
      setdescription("");
      setshirtname("");
      setloader1(false);
      setTimeout(() => {
        setmsg("");
      }, 1500);
      settgarments((prev) => [...prev, garmentData.data.createGarment]);
    } catch (error) {
      seterrMsg(error.message);
      setTimeout(() => {
        seterrMsg("");
      }, 1500);
      setloader1(false);
    }
    setopenmodal(false);
  };

  const handlepriceChange = (e) => {
    setprice(e.target.value);
  };
  const handlenameChange = (e) => {
    setshirtname(e.target.value);
  };
  const handledescChange = (e) => {
    setdescription(e.target.value);
  };

  useEffect(() => {
    API.get("laetusapi", "/api/v1/getshirtname")
      .then((res) => {
        setwebflowShirt(res.items);
      })
      .catch((err) => {
        return err;
      });
  }, [condition === "garments" && frtimgaddress && bckimgaddress]);

  useEffect(() => {
    if (auth !== "signin" || email) {
      if (!email.includes("@") || !email.includes(".") || email.length < 5) {
        setEmailError(t("emailerror"));
      } else {
        setEmailError(t(""));
      }
    }
  }, [email]);

  useEffect(() => {
    if (auth !== "signin" || password) {
      if (password.length < 8) {
        setpasswordError(t("passworderror"));
      } else {
        setpasswordError(t(""));
      }
    }
  }, [password]);

  useEffect(() => {
    if (userName.length > 18) {
      setUserNameError(t("usernameerr"));
    } else {
      setUserNameError(t(""));
    }
  }, [userName]);

  const uploaddgarment = () => {
    if (code === process.env.REACT_APP_PASSWORD) {
      setopenmodal(false);
    } else {
      seterrMsg(t("invalid-code"));
      setTimeout(() => {
        seterrMsg("");
      }, 2000);
    }
  };

  async function signUp(e) {
    e.preventDefault();
    if (!emailerror && !passwordError && !userNameError) {
      setloader1(true);
      setmsg("");
      seterrMsg("");
      try {
        const Signup = await Auth.signUp({
          username: email,
          password: password,
        });
        if (Signup) {
          const user = {
            userId: Signup.userSub,
            userName: userName,
            email: email,
            paypalEmail: "",
            accountNo: "",
            ibanNo: "",
            WebflowCustomerId: "",
          };
          await API.post("laetusapi", "/api/v1/mailchimp", {
            body: {
              email: email,
              userName: userName,
            },
          });

          await API.graphql({
            query: createUserInfo,
            authMode: "API_KEY",
            variables: {
              input: user,
            },
          });
          setmsg(t("succesfully-sign"));
          setAuthstate("confirmation");
          setloader1(false);
          setTimeout(() => {
            setmsg("");
          }, 1500);
        }
      } catch (error) {
        seterrMsg(error.message);
        setloader1(false);
      }
    }
  }

  async function signIn(e) {
    e.preventDefault();
    setloader1(true);
    seterrMsg("");
    try {
      const user = await Auth.signIn(email, password);

      dispatch(
        login({
          loginStatus: true,
          userDetail: user.attributes.sub,
          email: user.attributes.email,
        })
      );
      setIcon(true);
      let nextTokens;
      let users;
      do {
        users = await API.graphql(
          graphqlOperation(byUserId, {
            userId: user.attributes.sub,
            nextTokens,
            limit: 500,
          })
        );
        nextTokens = users.data.byUserId.nextToken;
      } while (nextTokens);
      dispatch(
        login({
          checkName: users?.data?.byUserId?.items[0]?.userName ? false : true,
          userName: users?.data?.byUserId?.items[0]?.userName,
          WebflowCustomerId: users?.data?.byUserId?.items[0]?.WebflowCustomerId,
        })
      );

      localStorage.setItem("email", user.attributes.sub);
      let nextToken = null;
      let items = [];
      setloader1(false);
      setopenmodal(false);
      try {
        const productImages = await API.graphql(
          graphqlOperation(productById, {
            id: user.attributes.sub,
            nextToken,
            limit: 100,
          })
        );
        // do {
        // 	const productImages = await API.graphql(
        // 		graphqlOperation(productById, {
        // 			customerId: user.attributes.sub,
        // 			nextToken,
        // 			limit: 100,
        // 		}),
        // 	);
        // 	items = items.concat(
        // 		productImages.data.productById.items.sort(
        // 			(a, b) =>
        // 				new Date(b.createdAt).getTime() -
        // 				new Date(a.createdAt).getTime(),
        // 		),
        // 	);
        // 	nextToken = productImages.data.productById.nextToken;
        // } while (nextToken);
        dispatch(
          campaignData({
            campaign: productImages.data.productById,
          })
        );
      } catch (error) {
        return error;
      }
    } catch (error) {
      seterrMsg(error.message);
      setTimeout(() => {
        seterrMsg("");
      }, 1500);

      if (error.message === "User is not confirmed.") {
        setAuthstate("confirmation");
      }
      setloader1(false);
    }
  }

  async function confirmSignUp() {
    setloader1(true);
    setmsg("");
    seterrMsg("");
    try {
      await Auth.confirmSignUp(email, verifycode);
      setloader1(false);
      setmsg(t("verifybtn"));
      setAuthstate("auth");
      setauth("signin");
      setVerifycode("");
      setEmail("");
      setpassword("");
      setTimeout(() => {
        setmsg("");
      }, 1500);
    } catch (error) {
      setloader1(false);
      seterrMsg(error.message);
    }
  }

  async function resendConfirmationCode() {
    setloader2(true);
    setmsg("");
    seterrMsg("");
    try {
      await Auth.resendSignUp(email);
      setmsg(t("codesend"));
      setloader2(false);
    } catch (err) {
      seterrMsg(err.message);
      setloader2(false);
    }
  }

  function forgotsend() {
    setloader2(true);
    setmsg("");
    seterrMsg("");
    Auth.forgotPassword(email)
      .then((data) => {
        setmsg(t("codesend"));
        setAuthstate("forgetpasswordcode");
        setloader2(false);
      })
      .catch((err) => {
        seterrMsg(err.message);
        setTimeout(() => {
          seterrMsg("");
        }, 1500);
        setloader2(false);
      });
  }

  function forgotcode() {
    setloader2(true);
    setmsg("");
    seterrMsg("");
    Auth.forgotPasswordSubmit(email, verifycode, password)
      .then((data) => {
        setmsg(t("new-passupdate"));
        setloader2(false);
        setAuthstate("auth");
        setauth("signin");
        setVerifycode("");
        setEmail("");
        setpassword("");
        seterrMsg("");
        setTimeout(() => {
          setmsg("");
        }, 1500);
      })
      .catch((err) => {
        seterrMsg(err.message);
        setloader2(false);
      });
  }

  const clrDel = (ind) => {
    setColarr((prev) => prev.filter((exp, index) => index !== ind));
  };

  useEffect(() => {
    if (shirtname) {
      const data = webflowShirt.filter((data) => data.name === shirtname);
      setwebflowData(data);
    }
  }, [shirtname]);

  const shirtUpload = () => {
    seterrMsg("");
    setmsg("");
    if (shirtname.length < 25) {
      setloader1(true);
      if (webflowData.length > 0) {
        uploadshirt(webflowData[0]);
      } else {
        API.post("laetusapi", "/api/v1/addshirtname", {
          body: {
            shirtname: shirtname,
          },
        })
          .then((res) => {
            uploadshirt(res);
          })
          .catch((err) => {
            setloader1(false);
          });
      }
    } else {
      seterrMsg(t("required-fields"));
      setTimeout(() => {
        seterrMsg("");
      }, 2000);
    }
  };

  return (
    <div>
      <Modal
        open={openmodal}
        onClose={modalcondFunc}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        onBackdropClick={true}
        disableEscapeKeyDown={escape && true}
      >
        {condition === "login" ? (
          <Box sx={style}>
            {authstate === "auth" ? (
              <>
                <h1>{t("sign")}</h1>
                <div>
                  <p className="auth-type">
                    <span
                      className={auth === "signin" && "clr"}
                      onClick={() => {
                        setEmail("");
                        setpassword("");
                        setEmailError(false);
                        setpasswordError(false);
                        setauth("signin");
                      }}
                    >
                      {t("sign_in")}
                    </span>
                    <span className="clr">|</span>
                    <span
                      className={auth === "signup" && "clr"}
                      onClick={() => {
                        setUsername("");
                        setEmail("");
                        setpassword("");
                        setEmailError(false);
                        setpasswordError(false);
                        setauth("signup");
                      }}
                    >
                      {t("sign_up")}
                    </span>
                  </p>
                  <form
                    onSubmit={
                      auth === "signin" ? (e) => signIn(e) : (e) => signUp(e)
                    }
                  >
                    {auth === "signup" && (
                      <>
                        <Inputfield
                          type="text"
                          value={userName}
                          onChange={(e) => setUsername(e.target.value)}
                          placeholder={t("username")}
                        />
                        {auth !== "signin" && userNameError && userName && (
                          <p className="errorclr">{t("usernameerr")}</p>
                        )}
                      </>
                    )}
                    <Inputfield
                      type="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder={t("email")}
                    />
                    {auth !== "signin" && emailerror && email && (
                      <p className="errorclr">{t("emailerror")}</p>
                    )}
                    <Inputfield
                      type="password"
                      value={password}
                      onChange={(e) => setpassword(e.target.value)}
                      placeholder={t("password")}
                    />
                    {auth !== "signin" && passwordError && password && (
                      <p className="errorclr">{t("passworderror")}</p>
                    )}
                    <input type="submit" hidden />
                  </form>
                  <div className="auth-confirm">
                    <p
                      className="forgetpassword"
                      onClick={() => {
                        setEmail("");
                        setpassword("");
                        setAuthstate("forgetpassword");
                      }}
                    >
                      {t("forget_password")}
                    </p>
                    <Buttons
                      text={
                        auth === "signin"
                          ? `> ${t("sign_in")}`
                          : `> ${t("sign_up")}`
                      }
                      onClick={
                        auth === "signin" ? (e) => signIn(e) : (e) => signUp(e)
                      }
                      loader={loader1}
                      className={"button signbtn"}
                    />
                  </div>
                </div>
              </>
            ) : authstate === "confirmation" ? (
              <>
                <h1>{t("auth-confirm")}</h1>
                <div>
                  <p className="auth-type">
                    <span className={"clr"}>{t("confirmcode")}</span>
                  </p>
                  <Inputfield
                    type="number"
                    value={verifycode}
                    onChange={(e) => setVerifycode(e.target.value)}
                    placeholder={t("verifycode")}
                  />
                  <div className="auth-confirm">
                    <Buttons
                      text={t("resendcode")}
                      onClick={() => resendConfirmationCode()}
                      className={"button signbtn"}
                      loader={loader2}
                    />

                    <Buttons
                      text={`> ${t("verifybtn")}`}
                      onClick={() => confirmSignUp()}
                      className={"button signbtn"}
                      loader={loader1}
                    />
                  </div>
                </div>
              </>
            ) : authstate === "forgetpassword" ? (
              <>
                <div
                  onClick={() => modalcondFunc()}
                  style={{ display: "flex", justifyContent: "right" }}
                  className="cp cancel"
                >
                  <span>x</span>
                </div>
                <h1>{t("design_loding")}</h1>
                <div>
                  <p className="auth-type">
                    <span className={"clr"}>{t("enter-email")}</span>
                  </p>
                  <Inputfield
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    placeholder={t("email")}
                  />
                  <div className="auth-confirm">
                    <Buttons
                      text={`> Retourner à la page de connexion`}
                      onClick={() => setAuthstate("auth")}
                      className="forgotbtn"
                    />
                    <Buttons
                      text={`> ${t("get")}`}
                      onClick={() => forgotsend()}
                      className={"button signbtn"}
                      loader={loader2}
                    />
                  </div>
                </div>
              </>
            ) : authstate === "forgetpasswordcode" ? (
              <>
                <div
                  onClick={() => modalcondFunc()}
                  style={{ display: "flex", justifyContent: "right" }}
                  className="cp cancel"
                >
                  <span>x</span>
                </div>
                <h1>{t("design_loding")}</h1>
                <div>
                  <p className="auth-type">
                    <span className={"clr"}>{t("confirmcode")}</span>
                  </p>
                  <Inputfield
                    type="number"
                    value={verifycode}
                    onChange={(e) => setVerifycode(e.target.value)}
                    placeholder={t("verifycode")}
                  />
                  <Inputfield
                    type="password"
                    value={password}
                    onChange={(e) => setpassword(e.target.value)}
                    placeholder={t("new-password")}
                  />
                  <div className="forgettbtn">
                    <Buttons
                      text={`> ${t("verifybtn")}`}
                      onClick={() => forgotcode()}
                      className={"button signbtn"}
                      loader={loader2}
                    />
                  </div>
                </div>
              </>
            ) : null}
          </Box>
        ) : congrates ? (
          <Box sx={style}>
            <div className="congrat">
              <div
                onClick={() => modalcondFunc()}
                style={{ display: "flex", justifyContent: "right" }}
                className="cp cancel"
              >
                <span>x</span>
              </div>
              <h1>{t("congrates")}</h1>
              <h3>{t("your_launched_campaign")}</h3>
              <p>{t("share_it")}</p>
              <div>
                <FacebookShareButton url={weflowProductURL}>
                  <FacebookIcon
                    className="icons"
                    style={{ marginRight: "15px" }}
                  />
                </FacebookShareButton>
                <TwitterShareButton url={weflowProductURL}>
                  <TwitterIcon className="icons" />
                </TwitterShareButton>
              </div>
              <CopyToClipboard
                text={weflowProductURL}
                onCopy={() => setCopied(true)}
              >
                <div className="link">
                  <p>
                    <span className="share-icon">
                      <ShareIcon />
                    </span>
                    <Tooltip arrow title={"Copy link"}>
                      <input type="text" value={weflowProductURL} disabled />
                    </Tooltip>
                  </p>
                </div>
              </CopyToClipboard>
            </div>
          </Box>
        ) : condition === "launch" && !congrates ? (
          <Box sx={style}>
            <div className="congrat">
              <div
                onClick={() => modalcondFunc()}
                style={{ display: "flex", justifyContent: "right" }}
                className="cp cancel"
              >
                <span>x</span>
              </div>
              <h1>{t("ready_launch")}</h1>
              <p>{t("no_longer_editable")}</p>
              <Buttons
                text={`> ${t("i_launch_campaign")}`}
                className="campaign-btn btn"
                onClick={() => doneprevroute()}
                loader={databtn}
              />
              <br />
              <Buttons
                text={`> ${t("modify_campaign")}`}
                className="modifier btn"
                onClick={() => describeroute()}
              />
            </div>
          </Box>
        ) : condition === "garments" && !congrates ? (
          <Box sx={style}>
            <div className="congrat">
              {uploadsection && (
                <div
                  onClick={() => modalcondFunc()}
                  style={{ display: "flex", justifyContent: "right" }}
                  className="cp cancel"
                >
                  <span>x</span>
                </div>
              )}
              <h1>{t("upload-img")}</h1>
              <br />
              {uploadsection ? (
                <div className="garments-img">
                  <div>
                    <img
                      src={frtimgaddress ? frtimgaddress : upload}
                      alt="profile-img"
                      width={200}
                      height={200}
                      style={{ borderRadius: "10%" }}
                    />
                    <label>
                      <input
                        type="file"
                        onChange={(e) => handleimagefrt(e)}
                        style={{ display: "none" }}
                        accept="image/png"
                      />
                      <br />
                      <span className="title cp">{t("upload-front")}</span>
                    </label>
                  </div>
                  <div>
                    <img
                      src={bckimgaddress ? bckimgaddress : upload}
                      alt="profile-img"
                      width={200}
                      height={200}
                      style={{ borderRadius: "10%" }}
                    />
                    <label>
                      <input
                        type="file"
                        onChange={(e) => handleimagebck(e)}
                        style={{ display: "none" }}
                        accept="image/png"
                      />
                      <br />
                      <span className="title cp">{t("upload-back")}</span>
                    </label>
                  </div>
                </div>
              ) : (
                <div>
                  <Inputfield
                    type="password"
                    placeholder={t("verification-password")}
                    onChange={(e) => setCode(e.target.value)}
                    value={code}
                  />
                  <Buttons
                    text={t("verify")}
                    className="modifier btn btnclr"
                    onClick={() => uploaddgarment()}
                  />
                </div>
              )}
              {frtimgaddress && bckimgaddress && (
                <>
                  <div className="d-flex" style={{ marginTop: "20px" }}>
                    <div className="d-flex ">
                      <Inputfield
                        type="number"
                        placeholder={t("cost-placeholder")}
                        onChange={(e) => handlepriceChange(e)}
                        value={price}
                      />
                      <span
                        className="align-center"
                        style={{ paddingLeft: "4px" }}
                      >
                        €
                      </span>
                    </div>

                    <div className="align-center">
                      <CatergorySelect
                        personName={personName}
                        setPersonName={setPersonName}
                        setcategoryData={setcategoryData}
                        categoryData={categoryData}
                      />
                    </div>
                  </div>
                  <div>
                    <SliderPicker
                      color={color}
                      onChange={(e) => {
                        setColor(e.hex);
                      }}
                      onChangeComplete={(e) => setColor(e.hex)}
                    />
                  </div>

                  <div style={{ display: "flex" }}>
                    <Inputfield
                      type="text"
                      onChange={(e) => {
                        setColor(e.target.value);
                      }}
                      value={color}
                    />
                    <div
                      className="colordiv"
                      style={{ background: color }}
                    ></div>
                    <div style={{ marginTop: "11px", marginLeft: "10px" }}>
                      <Buttons
                        text="Add"
                        onClick={() => setColarr((prev) => [...prev, color])}
                      />
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      marginLeft: "10px",
                      height: colArray.length > 0 ? "30px" : "0px",
                      overflow: "auto",
                    }}
                  >
                    {colArray?.map((data, ind) => {
                      return (
                        <div className="clr-span-div">
                          <span
                            key={ind}
                            className="clr-span"
                            style={{
                              background: data,
                            }}
                          ></span>
                          <span>{data}</span>
                          <span
                            className="cancel cp"
                            onClick={() => clrDel(ind)}
                          >
                            x
                          </span>
                        </div>
                      );
                    })}
                  </div>
                  <div>
                    <Inputfield
                      type="text"
                      placeholder={t("garmentname-placeholder")}
                      onChange={(e) => handlenameChange(e)}
                      value={shirtname}
                    />
                  </div>
                  {shirtname.length > 25 && (
                    <span className="cost-err">{t("name-lenght")}</span>
                  )}
                  <div>
                    <Inputfield
                      type="text"
                      placeholder={t("garmentdesc-placeholder")}
                      onChange={(e) => handledescChange(e)}
                      value={description}
                    />
                  </div>
                  <div style={{ textAlign: "center" }}>
                    {price > 0 &&
                      personName.length > 0 &&
                      colArray.length > 0 &&
                      description &&
                      shirtname && (
                        <Buttons
                          text={`> ${t("modify_campaign")}`}
                          className="modifier btn btnclr"
                          onClick={() => shirtUpload()}
                          loader={loader1}
                        />
                      )}
                  </div>
                </>
              )}
            </div>
          </Box>
        ) : condition === "productCategory" || "editProductCategory" ? (
          <Box sx={style}>
            <div
              onClick={() => modalcondFunc()}
              style={{ display: "flex", justifyContent: "right" }}
              className="cp cancel"
            >
              <span>x</span>
            </div>
            <ProductCategory
              setopenmodal={setopenmodal}
              item={catItem}
              editCat={editCat}
            />
          </Box>
        ) : null}
      </Modal>
      {msg || errMsg ? <Snackbar message={msg} errMessage={errMsg} /> : null}
      {copied && <Snackbar message="Copied!" />}
    </div>
  );
}
